import { useQuery } from 'react-query';
import axiosInstance from '../config/Axios';

// Customer "Screen health". Reads the tenant health endpoints built in Device Health step 1 and uses only their
// additive `customer` block. Restart / re-download are NOT here: the page reuses the existing
// useRestartDevice (GET /device/{id}/restart) and useFlushDevice (GET /device/{id}/screen) mutations.

const unwrap = (body) => body?.data ?? body ?? null;

const getFleetHealth = async () => {
  const { data } = await axiosInstance.get('/devices/health/fleet');
  return unwrap(data)?.customer ?? null;
};

export const useFleetHealth = () => useQuery(['screenHealthFleet'], getFleetHealth, { refetchInterval: 30000, retry: 1 });

const getScreenHealth = async ({ queryKey }) => {
  const [, id] = queryKey;
  const { data } = await axiosInstance.get(`/device/${id}/health`, { params: { days: 1 } });
  const body = unwrap(data);
  return body?.customer ?? data?.customer ?? null;
};

export const useScreenHealth = (id) => useQuery(['screenHealth', id], getScreenHealth, { enabled: !!id, refetchInterval: 15000, retry: 1 });

// The day log of ONE past local day (the «آخر 7 أيام» strip). Today keeps using useScreenHealth's own log.
const getScreenDayLog = async ({ queryKey }) => {
  const [, id, day] = queryKey;
  const { data } = await axiosInstance.get(`/device/${id}/health`, { params: { days: 1, day } });
  const c = unwrap(data)?.customer ?? data?.customer ?? null;
  return c ? { log: c.log || [], day: c.log_day || day } : null;
};

export const useScreenDayLog = (id, day) => useQuery(['screenDayLog', id, day], getScreenDayLog, { enabled: !!id && !!day, staleTime: 60000, retry: 1 });
